export const RESUME_PATH = "/resume/joshua-welford-resume.pdf"
export const VCARD_PATH = "/resume/joshua-welford.vcf"
export const SITE_ROUTES = [
  { to: "/", label: "Home", group: "Navigation", keywords: ["intro", "joshua", "welford"] },
  { to: "/music", label: "Music", group: "Navigation", keywords: ["listening", "music bot", "spotify"] },
  { to: "/listen-together", label: "Listen Together", group: "Navigation", keywords: ["spotify", "listen", "room", "sync"] },
  { to: "/activities", label: "Activities", group: "Navigation", keywords: ["presence", "discord", "live"] },
  { to: "/teletext", label: "Teletext", group: "Navigation", keywords: ["ceefax", "retro", "text", "terminal"] },
  { to: "/memories", label: "Memories", group: "Navigation", keywords: ["canvas", "collaboration", "board"] },
  { to: "/contact", label: "Contact", group: "Navigation", keywords: ["email", "work"] },
]

export const COMMANDS = [
  ...SITE_ROUTES.map(route => ({
    id: `route:${route.to}`,
    label: route.label,
    group: route.group,
    kind: "route",
    to: route.to,
    keywords: route.keywords,
  })),
  {
    id: "booking:start",
    label: "Start booking",
    group: "Work",
    kind: "event",
    eventName: "wf:open-booking",
    fallbackPath: "/",
    keywords: ["hire", "meeting", "calendar", "work together"],
  },
  {
    id: "resume:request",
    label: "Request CV",
    group: "Work",
    kind: "event",
    eventName: "wf:request-cv",
    keywords: ["cv", "resume", "pdf", "recruiter"],
  },
  {
    id: "contact:vcard",
    label: "Add to Contacts",
    group: "Work",
    kind: "download",
    href: VCARD_PATH,
    keywords: ["vcard", "vcf", "email"],
  },
  {
    id: "music:ask",
    label: "Ask music",
    group: "Experiments",
    kind: "event",
    eventName: "wf:open-music-chat",
    fallbackPath: "/music",
    keywords: ["music bot", "listening history", "ai"],
  },
]
